module.exports = __webpack_public_path__ + "static/img/8-8.cc1c32e7.jpeg";